import { useEffect, useState } from 'react';
import { useGetServiceQuoteMutation } from '@/components/orders/services/orderApi';

/**
 * Live price preview for the Order Service modal. Fires POST /services/quote
 * whenever (slug, quantity) changes and exposes the quoted subtotal. Returns
 * `null` until a quote resolves (and on error), so the modal can fall back to
 * a client-side estimate without blocking the user.
 */
export function useServiceQuote(slug: string | null, quantity: number) {
  const [getQuote, { isLoading }] = useGetServiceQuoteMutation();
  const [subtotal, setSubtotal] = useState<number | null>(null);

  useEffect(() => {
    if (!slug || quantity <= 0) {
      setSubtotal(null);
      return;
    }
    let cancelled = false;
    setSubtotal(null);
    getQuote({ items: [{ shoppingCartSlug: slug, quantity }] })
      .unwrap()
      .then((res) => { if (!cancelled) setSubtotal(res.subtotal); })
      .catch(() => { if (!cancelled) setSubtotal(null); });
    return () => { cancelled = true; };
  }, [slug, quantity, getQuote]);

  return { subtotal, isLoading };
}
